import { render } from "./TheManagerLocations.vue?vue&type=template&id=7b08f9e8"
import script from "./TheManagerLocations.vue?vue&type=script&lang=js"
export * from "./TheManagerLocations.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__